import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography, LinearProgress } from "@material-ui/core";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  linearProgressBox: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    "& .MuiLinearProgress-root": {
      height: 8,
      borderRadius: 4,
    },
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
    },
  },
}));

/** */
const LinearProgressWithLabel = (props) => {
  const classes = useStyles();
  return (
    <Box className={classes.linearProgressBox}>
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${props.value}%`}</Typography>
      </Box>
    </Box>
  );
};
LinearProgressWithLabel.propTypes = {
  value: PropTypes.number,
};

export default LinearProgressWithLabel;
